import React from 'react';

import type { Action } from 'flow/store/engine/types';
import type { FormState } from 'flow/editor/components/NodeEditorDrawer/useNodeEditorForm';
import type { useModalGroup } from 'flow/editor/hooks';

import ConfirmDataTypeChangeModal from './ConfirmDataTypeChangeModal';
import ReplaceWithPublishedAttributeModal from './ReplaceWithPublishedAttributeModal';
import { footerModalsNames } from './constants';
import type { FooterModalsNames } from './types';


interface FooterModalsProps {
  extraProps: {
    [footerModalsNames.confirmDataTypeChange]: {
      focusedAction: Action;
      focusedActionDependents: Action[];
      onSave(data: FormState): void;
    };
  };
  modalGroup: ReturnType<typeof useModalGroup<FooterModalsNames>>;
}

export default function AttributeConfigurationFooterModals({
  extraProps,
  modalGroup,
}: FooterModalsProps) {
  const modalMap: Record<FooterModalsNames, JSX.Element> = React.useMemo(() => ({
    confirmDataTypeChange: (
      <ConfirmDataTypeChangeModal
        isOpen
        modalGroup={modalGroup}
        {...extraProps[footerModalsNames.confirmDataTypeChange]}
      />
    ),
    replaceWithPublishedAttribute: (
      <ReplaceWithPublishedAttributeModal isOpen modalGroup={modalGroup} />
    ),
  }), [extraProps, modalGroup]);

  return modalMap[modalGroup.openedModal] ?? null;
}
